import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  getAllGoods,
  saveGoods,
  updateGoods,
  deleteGoods,
} from "../api/goodsApi";
import "../style/goods.css";
import { FaBox, FaEdit, FaTrash } from "react-icons/fa";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Goods = () => {
  const navigate = useNavigate();

  const [goodsName, setGoodsName] = useState("");
  const [goodsList, setGoodsList] = useState([]);
  const [editId, setEditId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [showEditModal, setShowEditModal] = useState(false);
  const [editingItem, setEditingItem] = useState(null);

  useEffect(() => {
    fetchGoods();
  }, []);

  const fetchGoods = async () => {
    try {
      setLoading(true);
      const res = await getAllGoods();

      const goodsData = res.data?.content || res.data || [];
      setGoodsList(Array.isArray(goodsData) ? goodsData : []);
    } catch (error) {
      console.error(error);
      toast.error("Failed to load goods");
      setGoodsList([]);
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    const name = goodsName.trim();

    if (!name) {
      toast.warning("Goods name is required");
      return;
    }

    try {
      if (editId) {
        await updateGoods(editId, { name });
        toast.success("Goods updated successfully");
      } else {
        await saveGoods({ name });
        toast.success("Goods saved successfully");
      }

      resetForm();
      fetchGoods();
    } catch (error) {
      handleError(error);
    }
  };

  const handleInlineEdit = (item) => {
    setGoodsName(item.name);
    setEditId(item.id);
  };

  const handleEdit = (item) => {
    setEditingItem({ ...item });
    setShowEditModal(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this item?")) return;

    try {
      await deleteGoods(id);
      toast.success("Goods deleted successfully");
      fetchGoods();
    } catch (error) {
      handleError(error);
    }
  };

  const resetForm = () => {
    setGoodsName("");
    setEditId(null);
  };

  const handleError = (error) => {
    if (error.response?.status === 401) {
      toast.error("Unauthorized - Please login again");
    } else if (error.response?.status === 403) {
      toast.error("Access denied");
    } else if (error.response?.status === 404) {
      toast.warning("Item already exists");
    } else if (error.response?.status === 400) {
      toast.warning(error.response.data?.message || "Bad request");
    } else {
      toast.error("Something went wrong");
    }
  };

  const handleAddCylinder = () => {
    navigate("/dashboard/cylinders");
  };

  const handleModalSave = async () => {
    if (!editingItem) return;
    
    try {
      await updateGoods(editingItem.id, { name: editingItem.name });
      toast.success("Goods updated successfully");
      setShowEditModal(false);
      setEditingItem(null);
      fetchGoods();
    } catch (error) {
      handleError(error);
    }
  };

  const handleModalClose = () => {
    setShowEditModal(false);
    setEditingItem(null);
  };

  const filteredGoods = goodsList.filter(
    (item) =>
      item.name &&
      item.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div style={{ 
      padding: '20px',
      maxWidth: '100vw',
      overflowX: 'hidden',
      minHeight: '100vh',
      boxSizing: 'border-box'
    }}>
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        marginBottom: '20px',
        flexWrap: 'wrap',
        gap: '10px',
        width: '100%',
        boxSizing: 'border-box'
      }}>
        <div style={{ 
          flex: '1', 
          minWidth: '200px',
          overflow: 'hidden'
        }}>
          <h2 style={{ 
            margin: 0,
            fontSize: 'clamp(1.2rem, 4vw, 1.8rem)',
            fontWeight: 'bold',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}>
            <FaBox style={{ fontSize: 'clamp(1.5rem, 4vw, 2rem)' }} />
            Inventory / Goods
          </h2>
        </div>
        <button
          type="button"
          onClick={handleAddCylinder}
          style={{ 
            padding: '10px 20px',
            border: '2px solid #e2e8f0',
            borderRadius: '8px',
            backgroundColor: '#ffffff',
            color: '#475569',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            fontSize: 'clamp(0.875rem, 2vw, 1rem)',
            fontWeight: '600',
            transition: 'all 0.2s ease',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
            position: 'relative',
            overflow: 'hidden'
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = '#f8fafc';
            e.target.style.borderColor = '#3b82f6';
            e.target.style.color = '#3b82f6';
            e.target.style.transform = 'translateY(-1px)';
            e.target.style.boxShadow = '0 4px 12px rgba(59, 130, 246, 0.15)';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = '#ffffff';
            e.target.style.borderColor = '#e2e8f0';
            e.target.style.color = '#475569';
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.1)';
          }}
          onMouseDown={(e) => {
            e.target.style.transform = 'translateY(-2px)';
          }}
          onMouseUp={(e) => {
            e.target.style.transform = 'translateY(-1px)';
          }}
        >
          <FaBox /> Add Cylinder
        </button>
      </div>

      {/* ===== FILTER CARD ===== */}
      <div className="card">
        <div className="form-row">

          <div className="input-group">
            <label>Search Goods</label>
            <input
              type="text"
              placeholder="Search goods by name..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>

          <div className="input-group">
            <label>Goods Name</label>
            <input
              type="text"
              placeholder="Enter goods name"
              value={goodsName}
              onChange={(e) => setGoodsName(e.target.value)}
            />
          </div>

          <div className="button-group">
            <button 
              type="button" 
              className="btn btn-secondary" 
              onClick={resetForm}
              style={{
                padding: '10px 20px',
                border: '2px solid #e2e8f0',
                borderRadius: '8px',
                backgroundColor: '#ffffff',
                color: '#64748b',
                cursor: 'pointer',
                fontSize: 'clamp(0.875rem, 2vw, 1rem)',
                fontWeight: '600',
                transition: 'all 0.2s ease',
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                position: 'relative',
                overflow: 'hidden'
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#f8fafc';
                e.target.style.borderColor = '#cbd5e1';
                e.target.style.color = '#475569';
                e.target.style.transform = 'translateY(-1px)';
                e.target.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = '#ffffff';
                e.target.style.borderColor = '#e2e8f0';
                e.target.style.color = '#64748b';
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.1)';
              }}
              onMouseDown={(e) => {
                e.target.style.transform = 'translateY(-2px)';
              }}
              onMouseUp={(e) => {
                e.target.style.transform = 'translateY(-1px)';
              }}
            >
              Reset
            </button>

            <button 
              type="button" 
              className="btn btn-primary" 
              onClick={handleSave}
              style={{
                padding: '10px 20px',
                border: '2px solid #3b82f6',
                borderRadius: '8px',
                backgroundColor: '#3b82f6',
                color: '#ffffff',
                cursor: 'pointer',
                fontSize: 'clamp(0.875rem, 2vw, 1rem)',
                fontWeight: '600',
                transition: 'all 0.2s ease',
                boxShadow: '0 4px 6px -1px rgba(59, 130, 246, 0.3)',
                position: 'relative',
                overflow: 'hidden'
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#2563eb';
                e.target.style.borderColor = '#2563eb';
                e.target.style.transform = 'translateY(-1px)';
                e.target.style.boxShadow = '0 10px 15px -3px rgba(59, 130, 246, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = '#3b82f6';
                e.target.style.borderColor = '#3b82f6';
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 4px 6px -1px rgba(59, 130, 246, 0.3)';
              }}
              onMouseDown={(e) => {
                e.target.style.transform = 'translateY(-2px)';
              }}
              onMouseUp={(e) => {
                e.target.style.transform = 'translateY(-1px)';
              }}
            >
              {editId ? "Update" : "Save"}
            </button>
            
            {editId && (
              <button type="button" className="btn btn-outline-warning btn-sm" onClick={resetForm}>
                Cancel
              </button>
            )}
          </div>

        </div>
      </div>

      {/* ===== TABLE CARD ===== */}
      <div className="table-card">

        {loading ? (
          <p className="loading">Loading goods...</p>
        ) : (
          <table>
            <thead>
              <tr>
                <th>Product Name</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>

              {!filteredGoods || filteredGoods.length === 0 ? (
                <tr>
                  <td colSpan="2" className="no-data">
                    No goods found
                  </td>
                </tr>
              ) : (
                filteredGoods.map((item) => (
                  <tr key={item.id}>
                    <td>{item.name}</td>

                    <td>
                      <div className="actions">

                        <button
                          type="button"
                          className="btn btn-outline-warning"
                          onClick={() => handleInlineEdit(item)}
                        >
                          <FaEdit /> Edit
                        </button>

                        <button
                          type="button"
                          className="btn btn-outline-danger"
                          onClick={() => handleDelete(item.id)}
                        >
                          <FaTrash /> Delete
                        </button>

                      </div>
                    </td>

                  </tr>
                ))
              )}

            </tbody>
          </table>
        )}

      </div>

      {/* Toast Notification */}
      <ToastContainer position="top-right" autoClose={3000} />

      {/* ===== EDIT MODAL ===== */}
      {showEditModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="modal-header">
              <h3>Edit Goods</h3>
              <button className="modal-close" onClick={handleModalClose}>
                ×
              </button>
            </div>
            <div className="modal-body">
              <div className="input-group">
                <label>Goods Name</label>
                <input
                  type="text"
                  value={editingItem?.name || ""}
                  onChange={(e) => setEditingItem({...editingItem, name: e.target.value})}
                  placeholder="Enter goods name"
                />
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-outline-secondary btn-sm" onClick={handleModalClose}>
                Cancel
              </button>
              <button type="button" className="btn btn-outline-primary btn-sm" onClick={handleModalSave}>
                Update
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Goods;